import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import { observer } from "mobx-react-lite";

import { classNames } from "primereact/utils";

import { applicationConfig } from "../../../../../environmentConfiguration";
import { useNavigationService } from "../../../../hooks/useNavigationService";
import { useStore } from "../../../../stores/StoreContext";
import { ActionButton } from "../../Buttons/ActionButton/ActionButton";

import "./FeatureList.scss";

export interface IFeatureListProps {
  collapsed: boolean;
}

const FeatureListRaw: FunctionComponent<IFeatureListProps> = (props: IFeatureListProps) => {
  const { t } = useTranslation();

  const { userStore, navigationStore } = useStore();

  const navigationService = useNavigationService();

  if (applicationConfig.featureFlags.enableTermsOfUse && !userStore.userAcceptedTermsOfUseAndPrivacyPolicy) {
    return null; // Do not render the feature selection if terms of use are not accepted and feature flag is enabled
  }

  return (
    <ul className="feature-list">
      {navigationService.availableFeatureMenuItems.map(item => {
        const isActive = item.path === navigationStore.currentActiveMenuItem?.path;

        return (
          <li
            key={item.path}
            className={classNames("feature-list-item", {
              active: isActive,
            })}
          >
            <Link to={item.url ?? ""} style={{ width: "100%" }}>
              <ActionButton
                id={item.label ?? `feature-list-item-icon-${item.id}`}
                icon={item.fontAwesomeIcon}
                label={props.collapsed ? undefined : t(item.label ?? "")}
                tooltip={t(item.label ?? "")}
                tooltipPosition="right"
                hideBackground={!isActive}
                tooltipDisabled={!props.collapsed}
                active={isActive}
                fullWidth={true}
              />
            </Link>
          </li>
        );
      })}
    </ul>
  );
};

export const FeatureList = observer(FeatureListRaw);
